/* eslint no-extend-native: "off" */

/*
 * String StartsWith Polyfill
 * Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
 */

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(search, pos) {
		return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	};
}


// WEBPACK FOOTER //
// ./src/polyfills/StringStartsWith.js